<template>
  <div v-if="audit">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailOrdreTravailTech.title', { code: audit.code }) }}
                <b-tag v-if="getLibelleEtat"
                       type="has-background-subMenu"
                       class="has-text-white mgl-5px">
                  {{ getLibelleEtat }}
                </b-tag>
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <a ref="lienDownload"></a>
        <div class="level-right">
          <dropdownButton
            @click="$router.push({
                  name: 'm.logistique.ordre_travail_audit-edit',
                  params: { id: audit.id }
                })"
            :permission="constantes.ORDRE_TRAVAIL_AUDIT.maj"
            type="is-addOrEdit"
            :actions="actionSecondary"
            class="mgr-2">
            {{ $t('general.button.edit') }}
          </dropdownButton>
            <piece-jointe-button
              class="mgr-2"
              :perm="constantes.ORDRE_TRAVAIL_AUDIT.maj"
              autoSave>
            </piece-jointe-button>
        </div>
      </div>
      <div class="tab mgh-0">
        <ul>
          <li :class="{'is-active': activeTab === 'audit'}"
              @click="activeTab = 'audit'">
            {{ $t('detailAudit.onglet.audit') }}
          </li>
          <li :class="{'is-active': activeTab === 'patrimoine'}"
              @click="activeTab = 'patrimoine'">
            {{ $t('detailAudit.onglet.patrimoine') }}
          </li>
        </ul>
      </div>
      <component :is="activeTab"
                 :audit="audit">
      </component>
    </div>
    <b-modal v-model="popUpEtat" has-modal-card class="modal">
      <pop-up-change-etat :message-header="messHeaderPopUpEtat"
                          :etat="etatToChange"
                          :audit="audit"
                          @update="updateEtat">
      </pop-up-change-etat>
    </b-modal>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('listeAudit.actionPopUp.supprimerAudit')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteAudits"/>
    </b-modal>
    <b-modal v-model="popUpCloturerDecloturer" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="messHeaderPopUpCloturerDecloturer"
        :messagesPopup="messagesPopUp"
        :isErrorPopup.sync="isErrorPopup"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpCloturerDecloturer = false"
        @yes="cloturerDecloturerAudit"/>
    </b-modal>
    <b-modal v-model="popUpSyncMatPicsToFaces" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="messHeaderPopUpSyncMatPicsToFaces"
        :messagesPopup="messagesPopUp"
        :isErrorPopup.sync="isErrorPopup"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpSyncMatPicsToFaces = false"
        @yes="syncMatPicsToFaces"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import {
  get, deleteAll, clotureDecloture,
} from '@/api/logistique/audit';
import audit from '@/components/logistique/audit/detail/audit/audit';
import patrimoine from '@/components/logistique/audit/detail/patrimoine/patrimoine';
import {
  ETAT_EN_COURS, ETAT_REALISE, ETAT_CLOTURER,
  ETAT_PLANIFIE, LIST_ETAT_AUDIT,
} from '@/configuration/logistique/audit/auditConf';
import messageErreur from '@/services/general/messageErreur';
import breadcrumb from '@/components/general/breadcrumb';
import { ORDRE_TRAVAIL_AUDIT } from '@/configuration/logistique/permissionsLogistiqueConf';
import transformGetAudit from '@/services/logistique/audit/transformGetAudit';
import PopUpChangeEtat from '@/components/logistique/audit/detail/p_changeEtat';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import validation from '@/services/logistique/audit/validation/validation';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import dropdownButton from '@/components/general/button/dropdownButton';
import { synchroniserLogoMaterielAll } from '@/api/gabed/materiel';

const Attachments = createNamespacedHelpers('attachments');
const Permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      audit: null,
      popUpEtat: false,
      messHeaderPopUpEtat: null,
      etatToChange: null,
      activeTab: 'audit',
      popUpSuppression: false,
      constantes: {
        ETAT_REALISE,
        ETAT_PLANIFIE,
        ETAT_EN_COURS,
        ORDRE_TRAVAIL_AUDIT,
        ETAT_CLOTURER,
      },
      popUpCloturerDecloturer: false,
      messagesPopUp: [],
      isErrorPopup: false,
      messHeaderPopUpCloturerDecloturer: null,
      cloturerOuDecloturer: false,
      popUpSyncMatPicsToFaces: false,
      messHeaderPopUpSyncMatPicsToFaces: null,
    };
  },
  components: {
    dropdownButton,
    audit,
    patrimoine,
    breadcrumb,
    PopUpChangeEtat,
    popUpPrevention,
    pieceJointeButton,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    actionSecondary() {
      const actions = [
        {
          label: this.$t('general.button.delete'),
          action: () => { this.popUpSuppression = true; },
          actionpermission: this.constantes.ORDRE_TRAVAIL_AUDIT.supprimer,
          order: 5,
        },
        {
          label: this.$t('detailAudit.actions.applyMatPicsToFaces'),
          action: () => { this.openSyncMatPic(); },
          order: 6,
        },
      ];

      if (this.audit.etat !== this.constantes.ETAT_REALISE) {
        actions.push(
          {
            label: this.$t('detailAudit.actions.realise'),
            action: () => { this.changerEtatOtTechnique(this.constantes.ETAT_REALISE); },
            actionpermission: this.constantes.ORDRE_TRAVAIL_AUDIT.maj,
            order: 1,
          },
        );
      }

      if (this.audit.etat !== this.constantes.ETAT_PLANIFIE) {
        actions.push(
          {
            label: this.$t('detailAudit.actions.planifie'),
            action: () => { this.changerEtatOtTechnique(this.constantes.ETAT_PLANIFIE); },
            actionpermission: this.constantes.ORDRE_TRAVAIL_AUDIT.maj,
            order: 2,
          },
        );
      }
      if (this.audit.etat !== this.constantes.ETAT_EN_COURS) {
        actions.push(
          {
            label: this.$t('detailAudit.actions.enCours'),
            action: () => { this.changerEtatOtTechnique(this.constantes.ETAT_EN_COURS); },
            actionpermission: this.constantes.ORDRE_TRAVAIL_AUDIT.maj,
            order: 3,
          },
        );
      }
      if (this.audit.etat === this.constantes.ETAT_REALISE
        || this.audit.etat === this.constantes.ETAT_CLOTURER) {
        actions.push(
          {
            label: this.audit.etat === this.constantes.ETAT_REALISE ? this.$t('detailAudit.actions.clos')
              : this.$t('detailAudit.actions.decloturer'),
            action: () => { this.openPopUpCloturerDecloturer(); },
            actionpermission: this.constantes.ORDRE_TRAVAIL_AUDIT.maj,
            order: 4,
          },
        );
      }
      return actions;
    },
    getLibelleEtat() {
      const etatFind = LIST_ETAT_AUDIT.find((etat) => {
        return etat.code === this.audit.etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('detailAudit.breadcrumb.liste'), route: { name: 'l.logistique.ordre_travail_audit' }, isActive: false },
        { title: this.$t('detailAudit.breadcrumb.detail'), route: '', isActive: true },
      ];
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async deleteAudits() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteAll({ otIds: [this.audit.id] });
        loadingComponent.close();
        messageSucces(this.$t('detailAudit.messages.success.delete'));
        await this.$router.push({ name: 'l.logistique.ordre_travail_audit' });
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async updateEtat() {
      this.popUpEtat = false;
      this.messHeaderPopUpEtat = '';
      this.etatToChange = '';
      await this.loadInfoAudit();
    },
    async loadInfoAudit() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.setAttachmentContext({ module: 'OrdreTravail' });
        const audit = (await get(this.$route.params.id)).data.result;
        await this.setAttachmentElementId({ id: audit.id });
        this.audit = await transformGetAudit(audit);
        this.setInformationPage(this.$t('pageGeneral.detail', { item: this.audit.code }));
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    changerEtatOtTechnique(etatSouhaite) {
      switch (etatSouhaite) {
        case ETAT_EN_COURS:
          this.messHeaderPopUpEtat = this.$t('detailAudit.popup.msgEncours');
          break;
        case ETAT_REALISE:
          this.messHeaderPopUpEtat = this.$t('detailAudit.popup.msgRealiser');
          break;
        case ETAT_PLANIFIE:
          this.messHeaderPopUpEtat = this.$t('detailAudit.popup.msgPlanifier');
          break;
        default:
          break;
      }
      this.etatToChange = etatSouhaite;
      this.popUpEtat = true;
    },
    openSyncMatPic() {
      this.messagesPopUp = [];
      this.isErrorPopup = false;
      this.popUpSyncMatPicsToFaces = true;
      this.messHeaderPopUpSyncMatPicsToFaces = this.$t('detailAudit.popup.syncMatPicsToFaces');
    },
    openPopUpCloturerDecloturer() {
      this.messagesPopUp = [];
      this.isErrorPopup = false;
      this.cloturerOuDecloturer = this.audit.etat === this.constantes.ETAT_REALISE;
      this.messHeaderPopUpCloturerDecloturer = this.cloturerOuDecloturer ? this.$t('detailAudit.popup.cloturerAudit')
        : this.$t('detailAudit.popup.decloturerAudit');
      this.popUpCloturerDecloturer = true;
    },
    async syncMatPicsToFaces() {
      const loadingComponent = this.$buefy.loading.open();
      this.messagesPopUp = [];
      this.isErrorPopup = false;
      try {
        const materielIds = this.audit.otPatrimoine.otsAuditEnfants.flatMap(otAuditEnfant => {
          return otAuditEnfant.otPatrimoine?.dispositif?.materiels?.map(mat => mat.id);
        }).filter(materielId => !!materielId);
        const synchroElement = [];
        materielIds.forEach((materielId) => {
          synchroElement.push({
            elementId: materielId,
            conserveAnciennePj: true,
          });
        });
        const params = { synchroElement };
        await synchroniserLogoMaterielAll(params);
        this.popUpSyncMatPicsToFaces = false;
        messageSucces(this.$t('detailAudit.messages.success.syncMatPicsToFaces'));
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesPopUp);
          this.isErrorPopup = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async cloturerDecloturerAudit() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesPopUp = [];
        this.isErrorPopup = false;
        await clotureDecloture({
          ids: [this.audit.id],
          cloture: this.cloturerOuDecloturer,
        });
        loadingComponent.close();
        this.popUpCloturerDecloturer = false;
        messageSucces(this.$i18n.t('detailAudit.messages.success.' + (this.cloturerOuDecloturer ? 'cloturer' : 'reactiver')));
        await this.loadInfoAudit();
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesPopUp);
          this.isErrorPopup = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    await this.loadInfoAudit();
  },
};

</script>
